module.exports = __webpack_public_path__ + "static/img/f_4.a6e523c4.png";